export const Menu = () => ({
  styleOverrides: {
    paper: {
      borderRadius: 8
    }
  }
});
export const MenuItem = () => ({
  styleOverrides: {
    root: {
      fontSize: 14,
      borderRadius: 8,
      marginInline: 8
    }
  }
});